import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-note-history',
  imports: [RmsModule],
  templateUrl: './note-history.component.html',
  styleUrl: './note-history.component.scss'
})
export class NoteHistoryComponent {
  Versions: any[] = [];

  constructor(@Inject(RMS_PULLDOWN_DATA) public data: any, public ref: RmsPulldownRef) {
    this.Versions = data?.versions || [];
  }

  close() {
    this.ref.close();
  }
}
